import React from 'react';

export type { ResizeArgs, ResizeMethod } from '@inertia-client';

export function resolveSSRPageComponent<T>(path: string|string[], pages: Record<string, Promise<T> | (() => Promise<T>)>): Promise<T> {
    for (const p of (Array.isArray(path) ? path : [path])) {
        const page = pages[p]

        if (typeof page === 'undefined') {
            continue
        }

        return typeof page === 'function' ? page() : page
    }

    return typeof pages['./pages/Page.tsx'] === 'function' ? pages['./pages/Page.tsx']() : pages['./pages/Page.tsx']
}

export async function resolvePageComponent<T>(path: string|string[], pages: Record<string, Promise<T> | (() => Promise<T>)>): Promise<T> {
    for (const p of (Array.isArray(path) ? path : [path])) {
        const page = pages[p]

        if (typeof page === 'undefined') {
            continue
        }

        return typeof page === 'function' ? page() : page
    }

    return typeof pages['./pages/Page.tsx'] === 'function' ? pages['./pages/Page.tsx']() : pages['./pages/Page.tsx']
}

export function mapArray<T, U>(array: T[] | null | undefined, callback: (item: T, index: number) => U): U[] {
    if (array && Array.isArray(array)) {
        return array.map(callback)
    }
    return [].map(callback);
}

// Helper function to safely render a button with null checks
export function safeButton(
    buttonText: string | null | undefined,
    buttonVariant: string | null | undefined,
    ButtonComponent: React.ComponentType<Record<string, unknown>>,
    additionalProps: Record<string, unknown> = {}
): React.ReactNode | null {
    if (!buttonText) return null;

    return React.createElement(ButtonComponent, {
        ...additionalProps,
        title: buttonText,
        variant: buttonVariant
    }, buttonText);
}

// Helper function to safely render an image with null checks
export function safeImage(
    imageSrc: string | null | undefined,
    imageAlt: string | null | undefined,
    blurhash: string | null | undefined,
    ImageComponent: React.ComponentType<Record<string, unknown>>,
    additionalProps: Record<string, unknown> = {}
): React.ReactNode | null {
    if (!imageSrc) return null;

    return React.createElement(ImageComponent, {
        ...additionalProps,
        src: imageSrc,
        alt: imageAlt || "",
        blurhash: blurhash
    });
}

// Helper function to safely render a link with null checks
export function safeLink(
    href: string | null | undefined,
    children: React.ReactNode,
    LinkComponent: React.ComponentType<Record<string, unknown>>,
    additionalProps: Record<string, unknown> = {}
): React.ReactNode | null {
    if (!href || !children) return null;

    return React.createElement(LinkComponent, {
        ...additionalProps,
        href: href
    }, children);
}

// Helper function to safely render conditional content
export function safeRender<T>(
    condition: T | null | undefined,
    renderFunction: (value: T) => React.ReactNode
): React.ReactNode | null {
    if (!condition) return null;
    return renderFunction(condition);
}
